import { FormControl } from '@angular/forms';

export function requiredFileType( fileTypes: string ) {
  return function (control: FormControl) {
    const file = control.value;
    if ( file ) {
      const extension = file.split('.').pop().toLowerCase();
      var archivoValido = (fileTypes.split(',').find(x=> x === extension) === undefined) ? false : true;

      if (!archivoValido) {
        return {
          requiredFileType: true
        };
      }
    }

    return null;
  };
}
